import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 20C14 18.8954 14.8954 18 16 18H80C81.1046 18 82 18.8954 82 20H14Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 29.56V64.44C13 65.6533 13.0009 66.4991 13.0581 67.156C13.1141 67.8 13.2185 68.1678 13.3711 68.4453C13.6453 68.9441 14.0559 69.3547 14.5547 69.6289C14.8322 69.7815 15.2 69.8858 15.844 69.9419C16.5009 69.9991 17.3467 70 18.56 70H77.44C78.6533 70 79.4991 69.9991 80.156 69.9419C80.8 69.8858 81.1678 69.7815 81.4453 69.6289C81.9441 69.3547 82.3547 68.9441 82.6289 68.4453C82.7815 68.1678 82.8858 67.8 82.9419 67.156C82.9991 66.4991 83 65.6533 83 64.44V29.56C83 28.3467 82.9991 27.5009 82.9419 26.844C82.8858 26.2 82.7815 25.8322 82.6289 25.5547C82.3547 25.0559 81.9441 24.6453 81.4453 24.3711C81.1678 24.2185 80.8 24.1141 80.156 24.0581C79.4991 24.0009 78.6533 24 77.44 24H18.56C17.3467 24 16.5009 24.0009 15.844 24.0581C15.2 24.1141 14.8322 24.2185 14.5547 24.3711C14.0559 24.6453 13.6453 25.0559 13.3711 25.5547C13.2185 25.8322 13.1141 26.2 13.0581 26.844C13.0009 27.5009 13 28.3467 13 29.56ZM12.4948 25.073C12 25.973 12 27.1687 12 29.56V64.44C12 66.8313 12 68.027 12.4948 68.927C12.8604 69.5922 13.4078 70.1396 14.073 70.5052C14.973 71 16.1686 71 18.56 71H77.44C79.8314 71 81.027 71 81.927 70.5052C82.5922 70.1396 83.1396 69.5922 83.5052 68.927C84 68.027 84 66.8313 84 64.44V29.56C84 27.1686 84 25.973 83.5052 25.073C83.1396 24.4078 82.5922 23.8604 81.927 23.4948C81.027 23 79.8314 23 77.44 23H18.56C16.1686 23 14.973 23 14.073 23.4948C13.4078 23.8604 12.8604 24.4078 12.4948 25.073Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.0489 52.4073C39.3373 52.9431 39.2024 53.9386 39.3727 54.7944C39.4266 55.0652 39.2508 55.3284 38.9799 55.3823C38.7091 55.4362 38.4459 55.2604 38.392 54.9895C38.1914 53.9816 38.2808 52.4867 39.4474 51.6084C40.6081 50.7345 42.603 50.6535 45.7578 51.887C46.7498 52.2748 47.4657 52.6369 47.9484 52.9795C47.9527 52.9825 47.957 52.9856 47.9612 52.9886C48.2503 52.9526 48.5462 52.923 48.8477 52.9C51.0423 52.7324 53.594 52.9108 56.1124 53.6002C56.3787 53.6731 56.5355 53.9482 56.4626 54.2145C56.3897 54.4808 56.1147 54.6377 55.8483 54.5647C53.4486 53.9078 51.0125 53.7376 48.9239 53.8971C48.8677 53.9013 48.8119 53.9059 48.7563 53.9106C48.7838 53.9901 48.8023 54.0721 48.8104 54.1568C48.8599 54.6748 48.511 55.0264 48.1926 55.2293C47.8632 55.4392 47.4308 55.5858 46.9936 55.6876C46.1147 55.8922 45.0503 55.9522 44.3199 55.8668C44.1349 55.8452 43.9565 55.8127 43.8007 55.7645C43.6596 55.7209 43.4724 55.6457 43.3327 55.4996C43.2557 55.4191 43.1821 55.3051 43.1556 55.1575C43.1287 55.0078 43.1588 54.87 43.2114 54.7586C43.3052 54.5601 43.4814 54.4203 43.6336 54.322C44.3261 53.8745 45.285 53.5106 46.4143 53.2556C46.1256 53.1181 45.7874 52.9723 45.3937 52.8184C42.3037 51.6103 40.7664 51.867 40.0489 52.4073ZM47.6646 54.0387C46.4357 54.2239 45.4036 54.5268 44.6561 54.8931C45.256 54.9313 46.0786 54.8738 46.7669 54.7136C47.1577 54.6227 47.4641 54.5077 47.6552 54.386C47.7694 54.3132 47.8042 54.2655 47.8136 54.2459C47.8098 54.2319 47.7957 54.1939 47.7462 54.1303C47.7245 54.1026 47.6976 54.072 47.6646 54.0387ZM47.8165 54.2358C47.817 54.2358 47.8168 54.2384 47.8147 54.2435C47.815 54.2383 47.816 54.2358 47.8165 54.2358Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48 47.8466C42.477 47.8466 38 43.3696 38 37.8466C38 32.3236 42.477 27.8466 48 27.8466C53.523 27.8466 58 32.3236 58 37.8466C58 43.3696 53.523 47.8466 48 47.8466ZM46.622 34.2616C46.5618 34.2214 46.4919 34.1983 46.4196 34.1948C46.3473 34.1912 46.2755 34.2074 46.2116 34.2414C46.1478 34.2755 46.0944 34.3262 46.0572 34.3882C46.0199 34.4502 46.0001 34.5212 46 34.5936V41.0996C46.0001 41.1719 46.0199 41.2429 46.0572 41.3049C46.0944 41.3669 46.1478 41.4176 46.2116 41.4517C46.2755 41.4858 46.3473 41.5019 46.4196 41.4983C46.4919 41.4948 46.5618 41.4717 46.622 41.4316L51.501 38.1796C51.5559 38.143 51.6009 38.0935 51.632 38.0354C51.6631 37.9773 51.6794 37.9125 51.6794 37.8466C51.6794 37.7807 51.6631 37.7158 51.632 37.6577C51.6009 37.5996 51.5559 37.5501 51.501 37.5136L46.621 34.2616H46.622Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26.95 65C26.9828 64.8384 27 64.6712 27 64.5C27 64.3288 26.9828 64.1616 26.95 64H73.5C73.7761 64 74 64.2239 74 64.5C74 64.7761 73.7761 65 73.5 65H26.95ZM22.05 65H21.5C21.2239 65 21 64.7761 21 64.5C21 64.2239 21.2239 64 21.5 64H22.05C22.0172 64.1616 22 64.3288 22 64.5C22 64.6712 22.0172 64.8384 22.05 65Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24.5,
			cy: 64.5,
			r: 1.5,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 91.5C24 91.2239 24.2239 91 24.5 91H71.5C71.7761 91 72 91.2239 72 91.5C72 91.7761 71.7761 92 71.5 92H24.5C24.2239 92 24 91.7761 24 91.5Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47,
			y: 71,
			width: 2,
			height: 20,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 18C44 16.8954 44.8954 16 46 16H50C51.1046 16 52 16.8954 52 18H44Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 71H32C32 72.1046 31.1046 73 30 73H22C20.8954 73 20 72.1046 20 71Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M47 73L41 91H42L47 76V73Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49 76L54 91H55L49 73V76Z",
			fill: "white",
			fillOpacity: .24
		})
	]
});
export default SvgVideoDark;
